import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const BackToPlatformContainer = styled.a`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  text-decoration: none;
  cursor: pointer;
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N0
      : props.theme.atlas.semantic.color.action.secondaryInverse
          .onSecondaryInverse};
  ${({ theme }) =>
    theme.isVaultVariant
      ? `font-size: 14px; font-family: ${theme.typography.fontFamily}; font-weight: 400;`
      : textStyleCss(theme.atlas.typography.semantic.bodySmall)};
  &:hover {
    background-color: ${(props) =>
      props.theme.isVaultVariant
        ? props.theme.newPalette.neutral.N900
        : props.theme.atlas.semantic.color.action.secondaryInverse.hover};
  }
`;

export const BackToPlatformText = styled.span<{ $navOpen?: boolean }>`
  display: flex;
  justify-content: start;
  overflow: hidden;
  white-space: nowrap;
  opacity: ${(props) => (props.$navOpen ? '1' : '0')};
  width: ${(props) => (props.$navOpen ? '100%' : '0%')};
  transition: all 0.36s;
`;
